export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15017.ad3699d8.jpg";